<template lang="pug">
  .bg-ltgray.fades(@click="$emit('click')", :class="{'opacity-0': !loaded}")
    img.block(:src="imgSrc(image.url)", :alt="image.alt", @load="load")
</template>

<script>
import Vue from 'vue'
export default {
  name: 'SeriesViewer__ThumbsView__Thumb',
  props: ['image'],
  data () {
    return {
      loaded: false
    }
  },
  methods: {
    load () {
      setTimeout(() => { this.loaded = true }, 500)
    },
    imgSrc (src) {
      if (!src) return ''
      const length = window.innerHeight * 209 / 800
      return Vue.thumbSrc(src, length, true)
    }
  }
}
</script>

<style scoped>
img{
  max-height:calc(100vh * 209/800);
}
</style>



// WEBPACK FOOTER //
// src/components/SeriesViewer__ThumbsView__Thumb.vue